import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import authHeader from '../config/authHeader';
import config from '../config/config';

const useAuth = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');


    const login = async () => {
        setError('');
        try {
            const formData = new FormData();
            formData.append('email', email);
            formData.append('password', password);

            const response = await fetch(`${config.apiBaseUrl}/4DACTION/KST_AuthLogin`, {
                method: 'POST',
                headers: authHeader(),
                body: formData,
            });

            const data = await response.json();

            console.log('Login response:', data);

            debugger;

            if (response.ok && data.accessToken) {
                sessionStorage.setItem('token', data.accessToken);
                navigate('/dashboard');
            } else {
                setError(data.response || 'Authentication failed');
            }
        } catch (err) {
            setError('Une erreur est apparue. Rééssayez.');
        }
    };

    const logout = () => {
        sessionStorage.removeItem('token');
        navigate('/');
    };

    const isLoggedIn = () => {
        return !!sessionStorage.getItem('token');
    };

    const getUserInfo = async () => {
        try {
            const token = sessionStorage.getItem('token');
            if (!token) {
                logout();
                return null;
            }

            const response = await fetch(`${config.apiBaseUrl}/4DACTION/KST_GetUserInfo`, {
                method: 'GET',
                headers: authHeader(),
            });

            if (response.status === 401) {
                logout();
                return null;
            }

            if (!response.ok) {
                throw new Error('Impossible de récupérer les infos utilisateur');
            }

            const userData = await response.json();

            return {
                UUID: userData.UUID,
                Nom: userData.Nom,
                Email: userData.Email,
            };
        } catch (error) {
            console.error("Erreur lors de la récupération des infos utilisateur", error);
            return null;
        }
    };

    const getUserNotifications = async () => {
        try {
            const response = await fetch(`${config.apiBaseUrl}/4DACTION/KST_getUserNotifications`, {
                method: 'GET',
                headers: authHeader(),
            });

            if (response.status === 401) {
                logout();
                return null;
            }

            if (!response.ok) {
                throw new Error('Impossible de récupérer les notifications');
            }

            const notifications = await response.json();
            return notifications;
        } catch (error) {
            console.error("Erreur lors de la récupération des notifications", error);
            return null;
        }
    };

    const editNotification = async (notif) => {

        const formData = new FormData();

        for (const key in notif) {
            if (notif.hasOwnProperty(key)) {
                if (key !== 'Info_Origine') {
                    formData.append(key, notif[key]);
                }
            }
        }

        try {
            const response = await fetch(`${config.apiBaseUrl}/4DACTION/KST_editNotification`, {
                method: 'POST',
                headers: authHeader(),
                body: formData,
            });

            if (!response.ok) throw new Error('Erreur lors de la mise à jour');

        } catch (err) {
            console.error(err);
        }
    };



    return {
        email,
        setEmail,
        password,
        setPassword,
        error,
        login,
        logout,
        isLoggedIn,
        getUserInfo,
        getUserNotifications,
        editNotification,
    };
};

export default useAuth;

export const handleTokenInvalidError = (error) => {
    if (error.message === 'token invalide') {
        sessionStorage.removeItem('token');
        window.location.href = '/login';
    }
};
